import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Fetches the list of cashier users from the backend.
 * 
 * Sends a GET request to the `/users` endpoint and returns the response.
 * Assumes that the request requires authentication and the token is handled inside `apiCall`.
 *
 * @returns {Promise<Object>} - The response data containing the list of cashier users.
 * 
 * @throws {Error} - Throws an error if the request fails or the server returns an error.
 * 
 * @author Susovan
 */
const fetchCashiers = async() => {
    return await apiCall(AUTH_ROUTES.USERS_API_ENDPOINT, { method: "GET" })
}

export default fetchCashiers